/* iter213 — Global AI low-balance banner. Renders ABOVE the main
   navbar across every admin/manager screen. Polls /api/ai/alert-status
   every 60 s. Shows nothing when alert_level === 'ok' or 'not_configured'. */
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { AlertTriangle } from 'lucide-react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

const STYLE = {
  warn:     { bg: 'bg-amber-50',   text: 'text-amber-900',   border: 'border-amber-300',  label: 'AMBER · Balance low' },
  high:     { bg: 'bg-orange-50',  text: 'text-orange-900',  border: 'border-orange-300', label: 'RED · Balance critical' },
  critical: { bg: 'bg-rose-50',    text: 'text-rose-900',    border: 'border-rose-300',   label: 'CRITICAL · Balance nearly exhausted' },
};

export default function AiAlertBanner() {
  const [data, setData] = useState(null);
  const [user, setUser] = useState(null);

  useEffect(() => {
    try {
      const raw = localStorage.getItem('user');
      if (raw) setUser(JSON.parse(raw));
    } catch { /* noop */ }
  }, []);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) return;
    const headers = { Authorization: `Bearer ${token}` };
    const poll = async () => {
      try {
        const r = await axios.get(`${API}/api/ai/alert-status`, { headers, timeout: 5000 });
        setData(r.data?.data);
      } catch { /* silent — never block UX */ }
    };
    poll();
    const id = setInterval(poll, 60_000);
    return () => clearInterval(id);
  }, []);

  if (!data) return null;
  if (data.alert_level === 'ok' || data.alert_level === 'not_configured') return null;
  const sty = STYLE[data.alert_level];
  if (!sty) return null;
  const isSuper = (user?.role === 'super_admin' || user?.role === 'platform_admin');

  return (
    <div className={`${sty.bg} ${sty.text} ${sty.border} border-b text-xs px-4 py-1.5 flex items-center justify-center gap-2`}
         data-testid="ai-global-alert-banner">
      <AlertTriangle className="w-3.5 h-3.5" />
      <span className="font-semibold uppercase tracking-wider text-[10px]">{sty.label}</span>
      <span>· Only {typeof data.pct_remaining === 'number' ? `${data.pct_remaining}%` : '—'} of the monthly AI budget remains.</span>
      {isSuper && (
        <Link to="/super/ai-usage" className="underline font-semibold ml-2" data-testid="ai-alert-banner-cta">
          Open AI Usage & Billing →
        </Link>
      )}
    </div>
  );
}
